import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

const GetResetPasswordCode = async (uid) => {
  /**
   * input: uid: users id
   * output: user role
   * description: fetches user role
   */

  try {
    const codeDoc = await doc(db, "UpdatePasswordCode", uid);
    const codeDocSnapshot = await getDoc(codeDoc);
    const userDocDetails = codeDocSnapshot.data();
    return userDocDetails.code;
  } catch (error) {
    console.log(error);
  }
};

export default GetResetPasswordCode;
